import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { getDishImageUrl } from '../../../services/api';
import { useCart } from '../../../contexts/CartContext';
import DishPopup from '../../restaurant/DishPopup';
import namkeFallback from '../../../assets/namke-fallback.png';

const formatPrice = (price) => `${(Number(price) || 0).toFixed(2)} €`;

const PopularDishCard = ({ dish, onCardClick, onPlusClick }) => {
  const { t } = useTranslation();
  const [imgError, setImgError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const { addToCart } = useCart();
  const imageUrl = !imgError ? (getDishImageUrl(dish) || namkeFallback) : namkeFallback;

  const handlePlusClick = (e) => {
    e.stopPropagation();
    setShowPopup(true);
    onPlusClick?.(dish);
  };

  return (
    <>
      <div
        className="snap-start shrink-0 w-36 sm:w-40 cursor-pointer group"
        onClick={() => onCardClick?.(dish)}
      >
        <div className="relative">
          <div className="w-full aspect-square rounded-2xl overflow-hidden bg-namke-cream">
            <img
              src={imageUrl}
              alt={dish.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
              decoding="async"
              onError={() => setImgError(true)}
            />
          </div>
          <button
            type="button"
            onClick={handlePlusClick}
            className="absolute -bottom-3 -right-1 w-9 h-9 rounded-full bg-namke-terracotta text-white flex items-center justify-center shadow-md hover:bg-[#CD3A16] hover:scale-105 active:scale-95 transition-all"
            aria-label={t('home.addToCart')}
          >
            <Plus size={18} />
          </button>
        </div>
        <div className="mt-4 px-0.5">
          <p className="font-display text-sm font-semibold text-namke-black line-clamp-2 leading-snug">{dish.name}</p>
          <p className="text-sm text-namke-darkGreen font-semibold mt-1">{formatPrice(dish.price)}</p>
        </div>
      </div>
      <DishPopup
        dish={dish}
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        onAddToCart={(cartItem) => {
          addToCart(cartItem);
          setShowPopup(false);
        }}
      />
    </>
  );
};

export default PopularDishCard;
